import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-rating',
    templateUrl: './ratings.component.html',
    styleUrls: ['./ratings.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RatingsComponent implements OnInit {


    constructor(private fb: UntypedFormBuilder){}

    @Input() rating: any;
    @Input() group: UntypedFormGroup;
    @Input() itemId: number;
    @Output() ratingClick: EventEmitter<any> = new EventEmitter<any>();

    inputName: string;
    ngOnInit() {
        this.inputName = this.itemId + '_rating';
        this.group = this.fb.group({
            ratings: [this.rating]
        });
    }

    onClick(rating: number): void {
        this.rating = rating.toString();
        this.ratingClick.emit({
            itemId: this.itemId,
            rating: rating
        });
    }

}


